import './scss/main.scss';
import './logos/digirati-logo-white.svg';
import './logos/logo-nlw.svg';

require('@annotation-studio/bundle');



// WEBPACK FOOTER //
// ./src/index.js